import React, { Component } from "react";
import Datablock from "./Datablock";

export default class PimaDbs extends Component {
  constructor() {
    super();
    this.state = {
      currentDeath: "3554",
      currentPositive: "232133",
      female: "52.27 %",
      male: "46.75 %",
      age2044: "44.03 %",
      age519: "17.64 %",
      age65: "12.09 %",
      age4554: "12.97 %",
      age5564: "10.88 %",
      age5: "2.35 %",
      deathImg: "logos/rip.png",
      positiveImg: "logos/coronavirus.png",
    };
  }
  render() {
    const {
      currentDeath,
      currentPositive,
      female,
      male,
      age2044,
      age4554,
      age5,
      age519,
      age5564,
      age65,
      positiveImg,
      deathImg,
    } = this.state;
    return (
      <div className="pimadblock">
        <Datablock
          number={currentPositive}
          title={"TOTAL CASES"}
          img={positiveImg}
        />
        <Datablock
          number={currentDeath}
          title={"TOTAL DEATHS"}
          img={deathImg}
        />
        <div
          className="columns datablock"
          style={{ marginRight: "0", paddingBottom: "4px" }}
        >
          <span className="dblock-text">FEMALE CASES</span>
          <span className="dblock-number">{female}</span>
        </div>
        <div
          className="columns datablock"
          style={{ marginRight: "0", paddingBottom: "4px" }}
        >
          <span className="dblock-text">MALE CASES</span>
          <span className="dblock-number">{male}</span>
        </div>
        <div
          className="columns datablock"
          style={{ marginLeft: "0", width: "100%" }}
        >
          <div className="dblockage">
            <span className="dblock-text">&#60;5 YEARS</span>
            <span className="dblock-number">{age5}</span>
          </div>
          <div className="dblockage">
            <span className="dblock-text">05-19 YEARS</span>
            <span className="dblock-number">{age519}</span>
          </div>
          <div className="dblockage">
            <span className="dblock-text">20-44 YEARS</span>
            <span className="dblock-number">{age2044}</span>
          </div>
          <div className="dblockage">
            <span className="dblock-text">45-54 YEARS</span>
            <span className="dblock-number">{age4554}</span>
          </div>
          <div className="dblockage">
            <span className="dblock-text">55-64 YEARS</span>
            <span className="dblock-number">{age5564}</span>
          </div>
          <div className="dblockage">
            <span className="dblock-text">65+ YEARS</span>
            <span className="dblock-number">{age65}</span>
          </div>
        </div>
        {/* 
        <Datablock number={age5} title={"<5 YEARS} />
        <Datablock number={age519} title={"05-19 YEARS} />
        <Datablock number={age2044} title={"20-44 YEARS} />
        <Datablock number={age4554} title={"45-54 YEARS} />
        <Datablock number={age5564} title={"55-64 YEARS} />
        <Datablock number={age65} title={"65+ YEARS} /> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PimaDbs.js